(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (typeof jQuery !== 'undefined') {
    $(document).ready(function () {
      console.log('jQuery is ready!');
      $(".brand-images-carousel-section").owlCarousel({
      dots: true,
      loop: true,
      autoplay: true,
      slideSpeed: 2000,
      margin: 10,
      responsiveClass: true,
      nav: true,
      autoplayHoverPause: true,
      navText: ["<i class=\"fa-solid fa-angles-left\" aria-hidden=\"true\"></i>", "<i class=\"fa-solid fa-angles-right\" aria-hidden=\"true\"></i>"],
      responsive: {
          0: {
              items: 2,
              nav: true,
          },
          500: {
              items: 3,
              nav: true,
          },
          1000: {
              items: 5,
              nav: true,
          },

          1200: {
              items: 9,
              nav: true,
          }
      }
  });
    });
  } else {
    console.error('jQuery is not defined. Make sure it is loaded.');
  }
});    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categories-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (typeof jQuery !== 'undefined') {
    $(document).ready(function () {
      console.log('jQuery is ready!');
      $(".home-cat-prods-carousel-section").owlCarousel({
      dots: true,
      loop: true,
      autoplay: true,
      slideSpeed: 2000,
      margin: 25,
      responsiveClass: true,
      nav: true,
      autoplayHoverPause: true,
      navText: ["<i class=\"fa-solid fa-angles-left\" aria-hidden=\"true\"></i>", "<i class=\"fa-solid fa-angles-right\" aria-hidden=\"true\"></i>"],
      responsive: {
          0: {
              items: 1,
              nav: true,
          },
          500: {
              items: 2,
              nav: true,
          },
          1000: {
              items: 3,
              nav: true,
          },

          1200: {
              items: 4,
              nav: true,
          }
      }
  });
    });
  } else {
    console.error('jQuery is not defined. Make sure it is loaded.');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["short-about"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var targets = document.querySelectorAll('deferred-media[data-autoplay="true"]');

  function injectFromTemplate(mediaEl) {
    var existingVideo = mediaEl.querySelector('video');
    if (existingVideo) return existingVideo;

    var tpl = mediaEl.querySelector('template');
    if (!tpl) return null;

    // Insert the template content AFTER the poster/button, not replacing the whole wrapper
    var frag = (tpl.content) ? tpl.content.cloneNode(true) : (function(){
      var tmp = document.createElement('div');
      tmp.innerHTML = tpl.innerHTML.trim();
      var f = document.createDocumentFragment();
      while (tmp.firstChild) f.appendChild(tmp.firstChild);
      return f;
    })();

    // Place it as the last child so the ratio wrapper still works
    mediaEl.appendChild(frag);

    return mediaEl.querySelector('video');
  }

  function ensureAttrs(video) {
    // Attributes
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('loop', '');
    video.setAttribute('preload', 'auto');
    video.removeAttribute('controls');

    // Properties (important for Safari/iOS)
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.autoplay = true;

    // Make sure it actually has a size; some themes need this for first frame to paint
    video.style.width = '100%';
    video.style.height = '100%';
    video.style.objectFit = 'cover';
  }

  function hidePoster(mediaEl) {
    var posterBtn = mediaEl.querySelector('.deferred-media__poster, .video-section__poster');
    if (posterBtn) {
      posterBtn.style.opacity = '0';
      posterBtn.style.pointerEvents = 'none';
      posterBtn.style.visibility = 'hidden';
    }
  }

  function tryPlay(video) {
    // Force load first; helps with blank-first-frame issues
    try { video.load(); } catch (e) {}

    var p;
    try {
      p = video.play();
    } catch (e) {
      // swallow
    }
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        // Will retry on events/visibility/interaction
      });
    }
  }

  function setupAutoplay(mediaEl) {
    // If theme exposes loadContent(), use it to hydrate from template
    if (typeof mediaEl.loadContent === 'function') {
      try { mediaEl.loadContent(false); } catch (e) {}
    }

    var video = injectFromTemplate(mediaEl);
    if (!video) return;

    ensureAttrs(video);

    // Retry logic: on canplay/loadeddata/playing
    var kick = function () { tryPlay(video); };

    video.addEventListener('loadedmetadata', kick, { once: true });
    video.addEventListener('canplay', function () {
      hidePoster(mediaEl);
      kick();
    }, { once: true });
    video.addEventListener('playing', function () {
      hidePoster(mediaEl);
    }, { once: true });

    // Visibility-based kick (some browsers require it to be in viewport)
    var onceVisibleKickDone = false;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !onceVisibleKickDone) {
            onceVisibleKickDone = true;
            kick();
            io.disconnect();
          }
        });
      }, { threshold: 0.1 });
      io.observe(mediaEl);
    } else {
      // Fallback: try after a tick
      setTimeout(kick, 300);
    }

    // User interaction fallback: any first tap/click resumes autoplay
    var userKick = function () {
      kick();
      window.removeEventListener('click', userKick);
      window.removeEventListener('touchstart', userKick);
      window.removeEventListener('keydown', userKick);
    };
    window.addEventListener('click', userKick, { once: true });
    window.addEventListener('touchstart', userKick, { once: true });
    window.addEventListener('keydown', userKick, { once: true });

    // Final timed retries (handles stubborn Safari cases)
    setTimeout(kick, 600);
    setTimeout(kick, 1500);
  }

  targets.forEach(setupAutoplay);
});

  } catch(e) { console.error(e); }
})();
})();
